import { mediaMax } from '@/app/styles/breakpoints'
import { Tag } from '@/shared/ui/components/Tag'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Flex, Typography } from 'antd'
import styled, { css } from 'styled-components'

export const AccountCard = styled(Flex)<{ $isSelected?: boolean }>`
  border-radius: 6px;
  padding: 16px;
  background: ${(props) =>
    props.$isSelected
      ? props.theme.colors.subpartners.selected
      : props.theme.colors.grayBackground};
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 192px;
  overflow: hidden;
  min-width: 0;
  box-shadow: ${(props) =>
    props.$isSelected ? '0 6px 12px 0 rgba(66, 74, 83, 0.12)' : 'none'};

  ${(props) =>
    !props.$isSelected &&
    css`
      &:hover {
        background: ${props.theme.colors.subpartners.hover};
        box-shadow: 0 6px 12px 0 rgba(66, 74, 83, 0.12);

        ${AccountCheck} {
          fill: ${props.theme.colors.checkbox.checked};
        }
      }
    `}

  ${(props) =>
    props.$isSelected &&
    css`
      ${AccountCheck} {
        fill: ${props.theme.colors.status.active};
      }
    `}
`

export const AccountTop = styled(Flex)``

export const AccountTitle = styled(Typography.Text)`
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const AccountCheck = styled(Icon)`
  fill: rgba(22, 22, 22, 0.25);
`

export const AccountDetails = styled(Flex)``

export const AccountOption = styled(Flex)`
  svg {
    margin-top: 2px;
    flex: 0 0 auto;
  }
`

export const AccountUser = styled(Typography.Text)`
  color: ${(props) => props.theme.colors.cardDescription};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const AccountBottom = styled(Flex)``

export const AccountPath = styled(Typography.Text)`
  color: ${(props) => props.theme.colors.cardDescription};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  height: 42px;
`

export const TypeLabel = styled(Tag)`
  && {
    overflow: hidden;
    max-width: 60%;
    padding: 0 2%;
    cursor: pointer;
  }
`

export const TypeText = styled.span<{ content: string }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMax.xxl} {
    ${(props) => {
      const length = props.content?.length || 0
      if (length > 10) return 'font-size: 12px;'
      return ''
    }}
  }

  ${mediaMax.xl} {
    ${(props) => {
      const length = props.content?.length || 0
      if (length > 20) return 'font-size: 8px;'
      if (length > 15) return 'font-size: 10px;'
      if (length > 10) return 'font-size: 12px;'
      return ''
    }}
  }

  ${mediaMax.lg} {
    ${(props) => {
      const length = props.content?.length || 0
      if (length > 10) return 'font-size: 14px;'
      return ''
    }}
  }

  ${mediaMax.sm} {
    ${(props) => {
      const length = props.content?.length || 0
      if (length > 20) return 'font-size: 8px;'
      if (length > 15) return 'font-size: 10px;'
      if (length > 10) return 'font-size: 12px;'
      return ''
    }}
  }
`
